import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { toast } from 'react-toastify';
import { productAPI } from '../../services/api';

interface StatusChangeDialogProps {
  open: boolean;
  onClose: () => void;
  product: any;
  onStatusChanged: () => void;
}

const StatusChangeDialog: React.FC<StatusChangeDialogProps> = ({
  open,
  onClose,
  product,
  onStatusChanged,
}) => {
  const [loading, setLoading] = useState(false);

  const handleStatusChange = async (newStatus: number) => {
    if (!product) return;

    setLoading(true);
    try {
      await productAPI.updateProductStatus(product.id, newStatus);
      
      toast.success(`Product status updated successfully to ${newStatus === 1 ? 'Active' : 'Inactive'}`);
      onStatusChanged();
      onClose();
    } catch (error: any) {
      console.error('Error updating product status:', error);
      toast.error(error.response?.data?.detail || 'Failed to update product status');
    } finally {
      setLoading(false);
    }
  };

  const productName = product?.name || 'Product';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          Confirm Status Change
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to change the status for this product?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Product: <strong>{productName}</strong>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={() => handleStatusChange(product?.productstatus === 1 ? 0 : 1)}
          disabled={loading}
          variant="contained"
          color={product?.productstatus === 1 ? 'error' : 'success'}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusChangeDialog; 